/**
 * Data Actions
 * Redux actions for fetching and managing application data
 * 
 * NOTE: User APIs have been removed. Use admin APIs from services/admin instead.
 * @deprecated These actions use removed user APIs. Update screens to use admin APIs.
 */

/**
 * Fetch dashboard data
 * @deprecated Use admin dashboard service instead
 */
export const fetchDashboard = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch wallet balance
 * @deprecated Use admin APIs instead
 */
export const fetchWalletBalance = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch wallet transactions
 * @deprecated Use admin APIs instead
 */
export const fetchWalletTransactions = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch all trades
 * @deprecated Use admin trade service instead
 */
export const fetchAllTrades = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch active trades
 * @deprecated Use admin trade service instead
 */
export const fetchActiveTrades = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch trade history
 * @deprecated Use admin trade service instead
 */
export const fetchTradeHistory = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch trade stats
 * @deprecated Use admin trade service instead
 */
export const fetchTradeStats = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch forex trades
 * @deprecated Use admin trade service instead
 */
export const fetchForexTrades = (params = {}) => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch crypto trades
 * @deprecated Use admin trade service instead
 */
export const fetchCryptoTrades = (params = {}) => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch gold trades
 * @deprecated Use admin trade service instead
 */
export const fetchGoldTrades = (params = {}) => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch referrals
 * @deprecated Use admin APIs instead
 */
export const fetchReferrals = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch KYC status
 * @deprecated Use admin KYC service instead
 */
export const fetchKYC = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Submit KYC documents
 * @deprecated Use admin KYC service instead
 */
export const submitKYC = (formData) => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Update KYC documents
 * @deprecated Use admin KYC service instead
 */
export const updateKYC = (formData) => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch KYC details
 * @deprecated Use admin KYC service instead
 */
export const fetchKYCDetails = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch payment methods
 * @deprecated Use admin payment service instead
 */
export const fetchPaymentMethods = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch bank accounts
 * @deprecated Use admin bank service instead
 */
export const fetchBankAccounts = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Add bank account
 * @deprecated Use admin bank service instead
 */
export const addBankAccount = (accountData) => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Update bank account
 * @deprecated Use admin bank service instead
 */
export const updateBankAccount = (accountId, accountData) => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch transactions
 * @deprecated Use admin transaction service instead
 */
export const fetchTransactions = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch symbols
 * @deprecated Use admin symbol service instead
 */
export const fetchSymbols = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};

/**
 * Fetch popups
 * @deprecated Use admin popup service instead
 */
export const fetchPopups = () => async (dispatch) => {
  return { success: false, error: 'User APIs removed. Use admin APIs from services/admin instead.' };
};
